<template>
    <h5 class="modal-title">
        <slot />
    </h5>
</template>

<script>
export default {

    name: 'ModalTitle'

};
</script>
